// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.fat-arrow-rappa {
  display: flex;
  justify-content: center;
}

.fat-arrow {
  align-items: center;
  background: #718355;
  color: black;
  display: flex;
  height: 80px;
  line-height: 15px;
  margin-right: 20px;
  position: relative;
  text-align: left;
  width: 180px;
}
.fat-arrow div.inner {
  font-size: 14px;
  font-weight: 500;
  margin-left: 56px;
}
.fat-arrow:nth-child(2) {
  background: #87986a;
}
.fat-arrow:nth-child(3) {
  background: #97a97c;
}
.fat-arrow:nth-child(4) {
  background: #b5c99a;
}
.fat-arrow:nth-child(5) {
  background: #cfe1b9;
}

.fat-arrow:after {
  content: "";
  border-bottom: 40px solid transparent;
  border-left: 20px solid #676666;
  border-top: 40px solid transparent;
  bottom: 0;
  height: 0;
  left: 0;
  width: 0;
  position: absolute;
}

.fat-arrow:before {
  content: "";
  position: absolute;
  border-bottom: 40px solid transparent;
  border-left: 20px solid #718355;
  border-top: 40px solid transparent;
  bottom: 0;
  height: 0;
  right: -20px;
  width: 0;
}

.flo-arrow {
  cursor: pointer;
  align-items: center;
  background: white;
  box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.75);
  color: #000;
  display: flex;
  font-weight: bold;
  height: 40px;
  justify-content: center;
  left: 4px;
  padding-left: 8px;
  position: absolute;
  width: 35px;
  z-index: 2;
}

.flo-arrow:after {
  content: "";
  border-bottom: 20px solid transparent;
  border-left: 8px solid #676666;
  border-top: 20px solid transparent;
  bottom: 0;
  height: 0;
  left: 0;
  position: absolute;
  width: 0;
}

.flo-arrow:before {
  content: "";
  border-bottom: 20px solid transparent;
  border-left: 8px solid white;
  border-top: 20px solid transparent;
  bottom: 0;
  height: 0;
  position: absolute;
  right: -7px;
  width: 0;
}

.fat-arrow:nth-child(2)::before {
  border-left-color: #87986a;
}

.fat-arrow:nth-child(3)::before {
  border-left-color: #97a97c;
}

.fat-arrow:nth-child(4)::before {
  border-left-color: #b5c99a;
}

.fat-arrow:nth-child(5)::before {
  border-left-color: #cfe1b9;
}

.timeline-date {
  font-weight: 700;
  margin-top: 8px;
}

@media only screen and (max-width: 1340px) {
  .fat-arrow {
    height: 100px;
    width: 130px;
  }
  .fat-arrow:after {
    border-bottom: 50px solid transparent;
    border-top: 50px solid transparent;
  }
  .fat-arrow:before {
    border-bottom: 50px solid transparent;
    border-top: 50px solid transparent;
  }
}
@media only screen and (max-width: 1066px) {
  .fat-arrow {
    height: 100px;
    width: 106px;
  }
  .fat-arrow div.inner {
    font-size: 10px;
  }
  .fat-arrow:after {
    border-bottom: 50px solid transparent;
    border-top: 50px solid transparent;
  }
  .fat-arrow:before {
    border-bottom: 50px solid transparent;
    border-top: 50px solid transparent;
  }
}
@media only screen and (max-width: 957px) {
  .fat-arrow {
    background: transparent;
    height: 100px;
    width: 60px;
  }
  .fat-arrow div.inner {
    display: none;
  }
  .fat-arrow:nth-child(2) {
    background: transparent;
  }
  .fat-arrow:nth-child(3) {
    background: transparent;
  }
  .fat-arrow:nth-child(4) {
    background: transparent;
  }
  .fat-arrow:nth-child(5) {
    background: transparent;
  }
  .fat-arrow:after {
    border: none;
  }
  .fat-arrow:before {
    border: none;
  }
  .flo-arrow {
    align-items: center;
    background: #718355;
    box-shadow: none;
    color: white;
    display: flex;
    font-weight: bold;
    height: 60px;
    justify-content: center;
    left: 3px;
    padding-left: 8px;
    position: absolute;
    width: 55px;
    z-index: 2;
  }
  .flo-arrow .two {
    background-color: #87986a;
  }
  .flo-arrow .three {
    background: #97a97c;
  }
  .flo-arrow:nth-child(4) {
    background: #b5c99a;
  }
  .flo-arrow:nth-child(5) {
    background: #cfe1b9;
  }
  .flo-arrow:after {
    content: "";
    border-bottom: 30px solid transparent;
    border-left: 8px solid #676666;
    border-top: 30px solid transparent;
    bottom: 0;
    height: 0;
    left: 0;
    position: absolute;
    width: 0;
  }
  .flo-arrow:before {
    content: "";
    border-bottom: 30px solid transparent;
    border-left: 8px solid #718355;
    border-top: 30px solid transparent;
    bottom: 0;
    height: 0;
    right: -7px;
    position: absolute;
    width: 0;
  }
  .two {
    background: #87986a;
  }
  .two:before {
    border-left: 8px solid #87986a;
  }
  .three {
    background: #97a97c;
  }
  .three:before {
    border-left: 8px solid #97a97c;
  }
  .four {
    background: #b5c99a;
  }
  .four:before {
    border-left: 8px solid #b5c99a;
  }
  .five {
    background: #cfe1b9;
  }
  .five:before {
    border-left: 8px solid #cfe1b9;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Timeline.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,uBAAA;AAUJ;;AAPA;EACI,mBAAA;EACA,mBD2Be;EC1Bf,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAUJ;AATI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAWR;AARI;EACI,mBDYW;ACFnB;AAPI;EACI,mBDSW;ACAnB;AANI;EACI,mBDMW;ACEnB;AALI;EACI,mBDGW;ACInB;;AAHA;EACI,WAAA;EACA,qCAAA;EACA,+BAAA;EACA,kCAAA;EACA,SAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAMJ;;AAJA;EACI,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,kCAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;AAOJ;;AAJA;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,+CAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAOJ;;AALA;EACA,WAAA;EACI,qCAAA;EACA,8BAAA;EACA,kCAAA;EACA,SAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;AAQJ;;AANA;EACA,WAAA;EACI,qCAAA;EACA,4BAAA;EACA,kCAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AASJ;;AALA;EACI,0BDpEe;AC4EnB;;AANA;EACI,0BDtEe;AC+EnB;;AAPA;EACI,0BDxEe;ACkFnB;;AARA;EACI,0BD1Ee;ACqFnB;;AARA;EACI,gBAAA;EACA,eAAA;AAWJ;;AAPA;EACI;IACI,aAAA;IACA,YAAA;EAUN;EARE;IACI,qCAAA;IACA,kCAAA;EAUN;EARE;IACI,qCAAA;IACA,kCAAA;EAUN;AACF;AAPA;EACI;IACI,aAAA;IACA,YAAA;EASN;EARM;IACI,eAAA;EAUV;EAPE;IACI,qCAAA;IACA,kCAAA;EASN;EAPE;IACI,qCAAA;IACA,kCAAA;EASN;AACF;AANA;EACI;IACI,uBAAA;IACA,aAAA;IACA,WAAA;EAQN;EAPM;IACI,aAAA;EASV;EAPM;IACI,uBAAA;EASV;EAPM;IACI,uBAAA;EASV;EAPM;IACI,uBAAA;EASV;EAPM;IACI,uBAAA;EASV;EANE;IACI,YAAA;EAQN;EANE;IACI,YAAA;EAQN;EAJE;IACI,mBAAA;IACA,mBDvJW;ICwJX,gBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;IACA,YAAA;IACA,uBAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;EAMN;EAJM;IACI,yBDpKO;EC0KjB;EAHM;IACI,mBDvKO;EC4KjB;EAFM;IACI,mBD1KO;EC8KjB;EADM;IACI,mBD7KO;ECgLjB;EAAE;IACI,WAAA;IACA,qCAAA;IACA,8BAAA;IACA,kCAAA;IACA,SAAA;IACA,SAAA;IACA,OAAA;IACA,kBAAA;IACA,QAAA;EAEN;EAAE;IACI,WAAA;IACA,qCAAA;IACA,8BAAA;IACA,kCAAA;IACA,SAAA;IACA,SAAA;IACA,WAAA;IACA,kBAAA;IACA,QAAA;EAEN;EAAE;IACI,mBD1MW;EC4MjB;EAAE;IACI,8BAAA;EAEN;EACE;IACI,mBDhNW;ECiNjB;EACE;IACI,8BAAA;EACN;EAEE;IACI,mBDtNW;ECsNjB;EAEE;IACI,8BAAA;EAAN;EAIE;IACI,mBD7NW;EC2NjB;EAIE;IACI,8BAAA;EAFN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.fat-arrow-rappa {\n    display: flex;\n    justify-content: center;\n}\n\n.fat-arrow {\n    align-items:center;\n    background: $timeline-arrow-1;\n    color: black;\n    display: flex;\n    height: 80px;\n    line-height: 15px;\n    margin-right: 20px;\n    position: relative;\n    text-align: left;\n    width: 180px;\n    div.inner {\n        font-size: 14px;\n        font-weight: 500;\n        margin-left: 56px;\n    }\n\n    &:nth-child(2) {\n        background: $timeline-arrow-2;\n    }\n\n    &:nth-child(3) {\n        background: $timeline-arrow-3;\n    }\n\n    &:nth-child(4) {\n        background: $timeline-arrow-4;\n    }\n\n    &:nth-child(5) {\n        background: $timeline-arrow-5;\n    }\n\n}\n.fat-arrow:after {\n    content: \"\";\n    border-bottom: 40px solid transparent;\n    border-left: 20px solid #676666;\n    border-top: 40px solid transparent;\n    bottom: 0;\n    height: 0;\n    left: 0;\n    width: 0;\n    position: absolute;\n}\n.fat-arrow:before {\n    content: \"\";\n    position: absolute;\n    border-bottom: 40px solid transparent;\n    border-left: 20px solid $timeline-arrow-1;\n    border-top: 40px solid transparent;\n    bottom: 0;\n    height: 0;\n    right: -20px;\n    width: 0;\n}\n\n.flo-arrow {\n    cursor: pointer;\n    align-items: center;\n    background: white;\n    box-shadow: 4px 4px 5px 0px rgba(0,0,0,0.75);\n    color: #000;\n    display: flex;\n    font-weight:bold;\n    height: 40px;\n    justify-content: center;\n    left: 4px;\n    padding-left: 8px;\n    position: absolute;\n    width: 35px;\n    z-index: 2;\n}\n.flo-arrow:after {\ncontent: \"\";\n    border-bottom: 20px solid transparent;\n    border-left: 8px solid #676666;\n    border-top: 20px solid transparent;\n    bottom: 0;\n    height: 0;\n    left: 0;\n    position: absolute;\n    width: 0;\n}\n.flo-arrow:before {\ncontent: \"\";\n    border-bottom: 20px solid transparent;\n    border-left: 8px solid white;\n    border-top: 20px solid transparent;\n    bottom: 0;\n    height: 0;\n    position: absolute;\n    right: -7px;\n    width: 0;\n}\n\n\n.fat-arrow:nth-child(2)::before {\n    border-left-color: $timeline-arrow-2;\n}\n.fat-arrow:nth-child(3)::before {\n    border-left-color: $timeline-arrow-3;\n}\n.fat-arrow:nth-child(4)::before {\n    border-left-color: $timeline-arrow-4;\n}\n.fat-arrow:nth-child(5)::before {\n    border-left-color: $timeline-arrow-5;\n}\n\n.timeline-date {\n    font-weight: 700;\n    margin-top: 8px;\n}\n\n\n@media only screen and (max-width: 1340px) {\n    .fat-arrow {\n        height: 100px;\n        width: 130px;\n    }\n    .fat-arrow:after {\n        border-bottom: 50px solid transparent;\n        border-top: 50px solid transparent;\n    }\n    .fat-arrow:before {\n        border-bottom: 50px solid transparent;\n        border-top: 50px solid transparent;\n    }\n}\n\n@media only screen and (max-width: 1066px) {\n    .fat-arrow {\n        height: 100px;\n        width: 106px;\n        div.inner {\n            font-size: 10px;\n        }\n}\n    .fat-arrow:after {\n        border-bottom: 50px solid transparent;\n        border-top: 50px solid transparent;\n    }\n    .fat-arrow:before {\n        border-bottom: 50px solid transparent;\n        border-top: 50px solid transparent;\n    }\n}\n\n@media only screen and (max-width: 957px) {\n    .fat-arrow {\n        background:transparent;\n        height: 100px;\n        width: 60px;\n        div.inner {\n            display: none;\n        }\n        &:nth-child(2) {\n            background: transparent;\n        }\n        &:nth-child(3) {\n            background: transparent;\n        }\n        &:nth-child(4) {\n            background: transparent;\n        }\n        &:nth-child(5) {\n            background: transparent;\n        }\n    }\n    .fat-arrow:after {\n        border: none;\n    }\n    .fat-arrow:before {\n        border: none;\n    }\n\n\n    .flo-arrow {\n        align-items: center;\n        background: $timeline-arrow-1;\n        box-shadow: none;\n        color: white;\n        display: flex;\n        font-weight:bold;\n        height: 60px;\n        justify-content: center;\n        left: 3px;\n        padding-left: 8px;\n        position: absolute;\n        width: 55px;\n        z-index: 2;\n\n        .two {\n            background-color: $timeline-arrow-2;\n        }\n\n        .three {\n            background: $timeline-arrow-3;\n        }\n\n        &:nth-child(4) {\n            background: $timeline-arrow-4;\n        }\n\n        &:nth-child(5) {\n            background: $timeline-arrow-5;\n        }\n    }\n    .flo-arrow:after {\n        content: \"\";\n        border-bottom: 30px solid transparent;\n        border-left: 8px solid #676666;\n        border-top: 30px solid transparent;\n        bottom: 0;\n        height: 0;\n        left: 0;\n        position: absolute;\n        width: 0;\n    }\n    .flo-arrow:before {\n        content: \"\";\n        border-bottom: 30px solid transparent;\n        border-left: 8px solid $timeline-arrow-1;\n        border-top: 30px solid transparent;\n        bottom: 0;\n        height: 0;\n        right: -7px;\n        position: absolute;\n        width: 0;\n    }\n    .two {\n        background: $timeline-arrow-2;\n    }\n    .two:before {\n        border-left: 8px solid $timeline-arrow-2;\n    }\n\n    .three {\n        background: $timeline-arrow-3;\n    }\n    .three:before {\n        border-left: 8px solid $timeline-arrow-3;\n    }\n\n    .four {\n        background: $timeline-arrow-4;\n    }\n    .four:before {\n        border-left: 8px solid $timeline-arrow-4;\n    }\n\n\n    .five {\n        background: $timeline-arrow-5;\n    }\n    .five:before {\n        border-left: 8px solid $timeline-arrow-5;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
